import React from "react"
import { Link } from "gatsby"
import Helmet from "react-helmet"
import SiteFooter from "./site-footer"
import "./layout.css"

const Layout = ({ children, activePage, showFooterNewsletter = true }) => {
  const isHome = !activePage

  return (
    <div className="site-shell">
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=DM+Mono:ital,wght@0,300;0,400;0,500;1,300&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;1,9..40,300&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <nav>
        <div className="container nav-inner">
          {isHome ? (
            <Link className="logo" to="/">catwomaniya</Link>
          ) : (
            <Link className="back-btn" to="/">← catwomaniya</Link>
          )}
        </div>
      </nav>
      <main className="site-main">{children}</main>
      <div className="container site-footer-shell">
        <SiteFooter showNewsletter={showFooterNewsletter} />
      </div>
    </div>
  )
}

export default Layout
